import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import {
  LayoutBackoffice,
  LayoutFull,
  LayoutLess,
  LayoutOperator,
} from "./components/layouts";

import ProtectedRoute from "./components/protectedRoute";



import * as Pages from "./pages";
import * as Admin from "./backoffice";
import * as Control from "./control";
import { Operator } from "./control";
import { useFacebookPixel } from "./utils/facebookPixel";
const withLayout = (Component, Layout) => (props) => (
  <Layout>
    <Component {...props} />
  </Layout>
);

export function App() {

  useFacebookPixel();
  return (
    <Switch>
        {/* <Route
        exact
        path="/register/:referralToken?"
        render={(x) => <LayoutLess children={<Pages.Register {...x} />} />}
      />*/}
      <Route
        exact
        path="/verify-account"
        render={(x) => <LayoutFull children={<Pages.VerifyAccount {...x} />} />}
      />
        {/*<Route
        exact
        path="/membership"
        render={(x) => <LayoutLess children={<Pages.Membership {...x} />} />}
      />
      <Route
        exact
        path="/paid-membership"
        render={(x) => (
          <LayoutLess children={<Pages.MembershipPayment {...x} />} />
        )}
      />
      <Route
        exact
        path="/error-membership"
        render={(x) => (
          <LayoutLess children={<Pages.MembershipPayment {...x} />} />
        )}
      />*/}
      <Route
        exact
        path="/reset-password"
        render={(x) => <LayoutFull children={<Pages.ResetPassword {...x} />} />}
      />
      <Route
        exact
        path="/home"
        render={(x) => <LayoutFull children={<Pages.Home />} />}
      />
      <Route
        exact
        path="/surveys"
        render={(x) => <LayoutFull children={<Pages.Surveys />} />}
      />
      <Route
        exact
        path="/board"
        render={(x) => <LayoutFull children={<Pages.Board />} />}
      />
      {/* <Route
        exact
        path="/messages"
        render={(x) => <LayoutFull children={<Pages.Messages />} />}
      /> */}
      {/* <Route
        exact
        path="/messages/:id"
        render={(x) => <LayoutFull children={<Pages.Messages />} />}
      /> */}
      <Route
        exact
        path="/discount"
        render={(x) => <LayoutFull children={<Pages.Discount />} />}
      />{" "}
      <Route
        exact
        path="/directory"
        render={(x) => <LayoutFull children={<Pages.Directory />} />}
      />
      <Route
        exact
        path="/ambassador"
        render={(x) => <LayoutFull children={<Pages.Ambassador />} />}
      />
      <Route
        exact
        path="/pride-music"
        render={(x) => <LayoutFull children={<Pages.PrideMusic />} />}
      />
      <Route
        exact
        path="/interest-group"
        render={(x) => <LayoutFull children={<Pages.InterestGroup />} />}
      />
      <Route
        exact
        path="/details-directory/:DirectoryId"
        render={(x) => <LayoutFull children={<Pages.DetailsDirectory />} />}
      />
      <Route
        exact
        path="/register-services"
        render={(x) => <LayoutFull children={<Pages.RegisterServices />} />}
      />
      <Route
        exact
        path="/register-services/:id"
        render={(x) => <LayoutFull children={<Pages.RegisterServices />} />}
      />
      <Route
        exact
        path="/register-services/card-tokenization-result/:isSuccess"
        render={(x) => (
          <LayoutFull children={<Pages.CardTokenizationResult />} />
        )}
      />
      <Route
        exact
        path="/provider/:id"
        render={(x) => <LayoutFull children={<Pages.Provider {...x} />} />}
      />
      <Route
        exact
        path="/pending-payment"
        render={(x) => <LayoutFull children={<Pages.CashPayment />} />}
      />
      <Route
        exact
        path="/shopping-history"
        render={(x) => <LayoutFull children={<Pages.ShoppingHistory />} />}
      />
      <Route
        exact
        path="/rewards"
        render={(x) => <LayoutFull children={<Pages.Rewards />} />}
      />
      <Route
        exact
        path="/redemption-history"
        render={(x) => <LayoutFull children={<Pages.RedemptionHistory />} />}
      />
      <Route
        exact
        path="/account-status"
        render={(x) => <LayoutFull children={<Pages.AccountStatus />} />}
      />
      <Route
        exact
        path="/profile"
        render={(x) => <LayoutFull children={<Pages.Profile />} />}
      />
      <Route
        exact
        path="/blog-company"
        render={(x) => (
          <LayoutFull
            children={
              <Pages.BlogCompanyPrimary titleComponent="Mundo Pride" {...x} />
            }
          />
        )}
      />
      <Route
        exact
        path="/our-company/:id"
        render={(x) => (
          <LayoutFull
            children={
              <Pages.CompanyPostPrimary titleComponent="Mundo Pride" {...x} />
            }
          />
        )}
      />
      <Route
        exact
        path="/our-company/:id/report/:reportId"
        render={(x, y, z) => (
          <LayoutFull
            children={
              <Pages.CompanyPostPrimary
                titleComponent="Mundo Pride"
                {...x}
                {...y}
              />
            }
          />
        )}
      />
      <Route
        exact
        path="/our-company/:id/:postId"
        render={(x, y) => (
          <LayoutFull
            children={
              <Pages.CompanyPostPrimary
                titleComponent="Mundo Pride"
                {...x}
                {...y}
              />
            }
          />
        )}
      />
      <Route
        exact
        path="/blog-company/gallery/:id?"
        render={(x) => (
          <LayoutFull
            children={
              <Pages.BlogGallery titleComponent="Galería Pride" {...x} />
            }
          />
        )}
      />
      <Route
        exact
        path="/stories-pride"
        render={(x) => (
          <LayoutFull
            children={
              <Pages.BlogCompanySecondary
                titleComponent="Orgullo LGBTQ+"
                {...x}
              />
            }
          />
        )}
      />
      <Route
        exact
        path="/stories-pride/:id"
        render={(x) => (
          <LayoutFull
            children={
              <Pages.CompanyPostSecondary
                titleComponent="Orgullo LGBTQ+"
                {...x}
              />
            }
          />
        )}
      />
      <Route
        exact
        path="/stories-pride/:id/report/:reportId"
        render={(x, y) => (
          <LayoutFull
            children={
              <Pages.CompanyPostSecondary
                titleComponent="Orgullo LGBTQ+"
                {...x}
                {...y}
              />
            }
          />
        )}
      />
      <Route
        exact
        path="/stories-pride/:id/:postId"
        render={(x, y) => (
          <LayoutFull
            children={
              <Pages.CompanyPostSecondary
                titleComponent="Orgullo LGBTQ+"
                {...x}
                {...y}
              />
            }
          />
        )}
      />
      <Route
        exact
        path="/help"
        render={(x) => <LayoutFull children={<Pages.Help />} />}
      />
      <Route
        exact
        path="/audience/:idAudience?"
        render={(x) => <LayoutFull children={<Pages.Audience />} />}
      />
      <Route
        exact
        path="/ecommerce"
        render={(x) => <LayoutFull children={<Pages.Ecommerce />} />}
      />
      <Route
        exact
        path="/caring-community"
        render={(x) => <LayoutFull children={<Pages.CaringCommunity />} />}
      />
      <Route
        exact
        path="/caring-community/:id"
        render={(x) => <LayoutFull children={<Pages.Provider {...x} />} />}
      />
      <Route
        exact
        path="/job-bank"
        render={(x) => <LayoutFull children={<Pages.JobBank />} />}
      />
      <Route
        exact
        path="/applicant-sent"
        render={(x) => <LayoutFull children={<Pages.ApplicantSent />} />}
      />
      <Route
        exact
        path="/list-new-jobs"
        render={(x) => <LayoutFull children={<Pages.ListNewJobs />} />}
      />
      <Route
        exact
        path="/details-job"
        render={(x) => <LayoutFull children={<Pages.DetailsJobs />} />}
      />
      <Route
        exact
        path="/details-job/:id"
        render={(x) => <LayoutFull children={<Pages.DetailsJobs />} />}
      />
      <Route
        exact
        path="/register-job"
        render={(x) => <LayoutFull children={<Pages.RegisterJobs />} />}
      />
      <Route
        exact
        path="/edit-job/:id"
        render={(x) => <LayoutFull children={<Pages.EditJob />} />}
      />
      <Route
        exact
        path="/jobs-published"
        render={(x) => <LayoutFull children={<Pages.JobsPublished />} />}
      />
      <Route
        exact
        path="/candidates/:id"
        render={(x) => <LayoutFull children={<Pages.CandidatesNominated />} />}
      />
      <Route
        exact
        path="/order-details/:id"
        render={(x) => <LayoutFull children={<Pages.OrderDetail {...x} />} />}
      />
      <Route
        exact
        path="/canceled"
        render={(x) => (
          <LayoutFull children={<Pages.PaymentCanceled {...x} />} />
        )}
      />
      {/* == BACKOFFICE == */}
      <ProtectedRoute
        exact
        path="/admin"
        allowedRoles={["Recursos Humanos"]}
        component={withLayout(Admin.Admin, LayoutBackoffice)}
      />
      <ProtectedRoute
        exact
        path="/admin/users"
        allowedRoles={["Recursos Humanos"]}
        component={withLayout(Admin.Users, LayoutBackoffice)}
      />
      <ProtectedRoute
        exact
        path="/admin/users-details/:id"
        allowedRoles={["Recursos Humanos"]}
        component={withLayout(Admin.UserDetails, LayoutBackoffice)}
      />
      <ProtectedRoute
        exact
        path="/admin/admin-audience"
        allowedRoles={["Recursos Humanos"]}
        component={withLayout(Admin.AdminAudience, LayoutBackoffice)}
      />
      <ProtectedRoute
        exact
        path="/admin/generic-section"
        allowedRoles={["Recursos Humanos"]}
        component={withLayout(Admin.AdminGenericSection, LayoutBackoffice)}
      />
      <ProtectedRoute
        exact
        path="/admin/bulk-load"
        allowedRoles={["Recursos Humanos"]}
        component={withLayout(Admin.BulkLoad, LayoutBackoffice)}
      />
      <ProtectedRoute
        exact
        path="/admin/AdminSurvey"
        allowedRoles={["Recursos Humanos"]}
        component={withLayout(Admin.AdminSurvey, LayoutBackoffice)}
      />
      <ProtectedRoute
        exact
        path="/admin/AdminSurveyScale/:surveyId"
        allowedRoles={["Recursos Humanos"]}
        component={withLayout(Admin.AdminSurveyScale, LayoutBackoffice)}
      />
      <ProtectedRoute
        exact
        path="/admin/AdminAnswerTypes"
        allowedRoles={["Recursos Humanos"]}
        component={withLayout(Admin.AdminAnswerTypes, LayoutBackoffice)}
      />
      <ProtectedRoute
        exact
        path="/admin/details-survey-scale/:surveyId/:id"
        allowedRoles={["Recursos Humanos"]}
        component={withLayout(Admin.DetailsSurveyScale, LayoutBackoffice)}
      />
      <ProtectedRoute
        exact
        path="/admin/details-survey/:id"
        allowedRoles={["Recursos Humanos"]}
        component={withLayout(Admin.DetailsSurvey, LayoutBackoffice)}
      />
      <ProtectedRoute
        exact
        path="/admin/survey-results/:id"
        allowedRoles={["Recursos Humanos"]}
        component={withLayout(Admin.SurveyResults, LayoutBackoffice)}
      />
      <ProtectedRoute
        exact
        path="/admin/AdminBoard"
        allowedRoles={["Recursos Humanos"]}
        component={withLayout(Admin.AdminBoard, LayoutBackoffice)}
      />
      <ProtectedRoute
        exact
        path="/admin/details-category"
        allowedRoles={["Recursos Humanos"]}
        component={withLayout(Admin.DetailsCategory, LayoutBackoffice)}
      />
      <ProtectedRoute
        exact
        path="/admin/details-category/:id"
        allowedRoles={["Recursos Humanos"]}
        component={withLayout(Admin.DetailsCategory, LayoutBackoffice)}
      />
      <ProtectedRoute
        exact
        path="/admin/control"
        allowedRoles={["Recursos Humanos"]}
        component={withLayout(Admin.Control, LayoutBackoffice)}
      />
      <ProtectedRoute
        exact
        path="/admin/company-event-type"
        allowedRoles={["Recursos Humanos"]}
        component={withLayout(Pages.AdminCompanyEventType, LayoutFull)}
      />
      <ProtectedRoute
        exact
        path="/admin/company-post"
        allowedRoles={["Recursos Humanos"]}
        component={withLayout(Admin.CompanyPost, LayoutBackoffice)}
      />
      <ProtectedRoute
        exact
        path="/admin/AdminGallery"
        allowedRoles={["Recursos Humanos"]}
        component={withLayout(Pages.AdminGallery, LayoutBackoffice)}
      />
      <ProtectedRoute
        exact
        path="/admin/CompanyGallery"
        allowedRoles={["Recursos Humanos"]}
        component={withLayout(Pages.CompanyGallery, LayoutBackoffice)}
      />
      <ProtectedRoute
        exact
        path="/admin/Notice"
        allowedRoles={["Recursos Humanos"]}
        component={withLayout(Admin.Notice, LayoutBackoffice)}
      />
      <ProtectedRoute
        exact
        path="/admin/product-filter"
        allowedRoles={["Recursos Humanos"]}
        component={withLayout(Admin.AdminProductFilter, LayoutBackoffice)}
      />
      <ProtectedRoute
        exact
        path="/admin/detail-product-filter/:id"
        allowedRoles={["Recursos Humanos"]}
        component={withLayout(Admin.DetailsProductFilter, LayoutBackoffice)}
      />
      <ProtectedRoute
        exact
        path="/admin/course"
        allowedRoles={["Recursos Humanos"]}
        component={withLayout(Admin.AdminCourse, LayoutBackoffice)}
      />
      {/* == OPERACIONES == */}
      <Route
        exact
        path="/operator"
        render={(x) => <LayoutOperator children={<Operator {...x} />} />}
      />
      <Route
        exact
        path="/operator/homeOps/:tap"
        render={(x) => (
          <LayoutOperator children={<Control.ControlReward {...x} />} />
        )}
      />
      <Route
        exact
        path="/operator/controlreward/:tap"
        render={(x) => (
          <LayoutOperator children={<Control.AdminReward {...x} />} />
        )}
      />
      <Route
        exact
        path="/operator/providers/:tap"
        render={(x) => (
          <LayoutOperator children={<Control.AdminRewardProvider {...x} />} />
        )}
      />
      <Route
        exact
        path="/operator/categories/:tap"
        render={(x) => (
          <LayoutOperator children={<Control.AdminRewardCategory {...x} />} />
        )}
      />
      <Route
        exact
        path="/operator/details-reward/:id"
        render={(x) => (
          <LayoutOperator children={<Control.DetailsReward {...x} />} />
        )}
      />
      <Route
        exact
        path="/operator/load-coupons/:id"
        render={(x) => (
          <LayoutOperator children={<Control.BulkLoadReward {...x} />} />
        )}
      />
      <Route
        exact
        path="/operator/details-rewardCategory/:id"
        render={(x) => (
          <LayoutOperator children={<Control.DetailsRewardCategory {...x} />} />
        )}
      />
      <Route
        exact
        path="/operator/details-rewardProvider/:id"
        render={(x) => (
          <LayoutOperator children={<Control.DetailsRewardProvider {...x} />} />
        )}
      />
      <Route
        exact
        path="/operator/AdminCompany"
        render={(x) => (
          <LayoutOperator children={<Control.AdminCompany {...x} />} />
        )}
      />
      <Route
        exact
        path="/operator/details-company/:id"
        render={(x) => (
          <LayoutOperator children={<Control.DetailsCompany {...x} />} />
        )}
      />
      <Route
        exact
        path="/admin/course"
        render={(x) => <LayoutBackoffice children={<Admin.AdminCourse />} />}
      />
        <Route
            exact
            path="/course-view"
            render={(x) => <LayoutFull children={<Pages.CourseView />} />}
        />
      <Route
        exact
        path="/course-view/course/:courseId"
        render={(x) => <LayoutFull children={<Pages.CourseView />} />}
      />
      <Route
        exact
        path="/course-view/new-event"
        render={(x) => <LayoutFull children={<Pages.EventForm />} />}
      />
      <Route
        exact
        path="/course-view/approve-event"
        render={(x) => <LayoutFull children={<Pages.EventApprove />} />}
      />
      <Route
        exact
        path="/course-view/my-events"
        render={(x) => <LayoutFull children={<Pages.EventApprove />} />}
      />
      <Redirect from="/" to="/home" />
    </Switch>
  );
}
